import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Button, IconButton } from '@material-ui/core'
import { toast } from 'react-toastify'
import { Field, formValueSelector, reduxForm } from 'redux-form'
import { renderTextField } from '../../../Forms/fieldRenderers'
import CamposPesado0 from '../pesado/CamposPesado0'
import { FORM_PESO_BRUTO } from '../../../../config/forms'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import { INTERVALO_LARGO } from '../../../../config/settings'

function PesadoBalanzaModoManual (props) {
  const { cpe, altaPesado, onBlurInput, deleteCpe } = props
  const [stepPesadoManual, setStepPesadoManual] = useState(0)

  useEffect(() => {
    const interval = setInterval(async () => {
      if (!cpe && stepPesadoManual !== 0) {
        setStepPesadoManual(0)
      }
    }, [INTERVALO_LARGO])
    return () => {
      clearInterval(interval)
    }
  }, [props, cpe, stepPesadoManual])

  const reset = () => {
    const { change: formChange } = props
    if (cpe && cpe.numero) {
      deleteCpe(cpe.numero)
    }
    setStepPesadoManual(0)
    formChange('numero', '')
    formChange('pesoBruto', '')
  }

  const submitAltaPesado = (e) => {
    const { pesoBruto, pesoMinimo } = props
    if (pesoBruto >= pesoMinimo) {
      setStepPesadoManual(2)
      altaPesado(e)
    } else {
      toast.error('El peso es menor al mínimo')
      reset()
    }
  }

  const handleSubmit = (e) => {
    const { numero } = props
    e.preventDefault()

    if ((String(numero).length === 11) && !isNaN(numero)) {
      setStepPesadoManual(1)
    } else {
      toast.error('Número invalido')
      reset()
    }
  }

  return (
    <div className='container-info-destare'>

      { stepPesadoManual === 2
        ? <div className='loader' />

        : <>

          { stepPesadoManual === 1
            ? <IconButton onClick={reset}>
              <ArrowBackIcon />
            </IconButton>
            : <></>
          }

          <div className='cabecera-pesado-manual'>
            <h5>Ingreso de peso manual</h5>
            { stepPesadoManual === 0 && !cpe && <h4 style={{ fontWeight: '600' }} >Lea o ingrese la carta de porte</h4> }
            { stepPesadoManual === 1 && <h4 style={{ fontWeight: '600' }}>Ingrese el peso de bruto</h4> }
          </div>

          { stepPesadoManual === 0 && <div className='campos-cea-destare'>
            <form onSubmit={handleSubmit}>
              <CamposPesado0
                label='Número de CTG'
                onBlurInput={onBlurInput}
              />
              <div style={{ visibility: '1', display: 'none' }}>
                <Button
                  type='submit'
                >
                        Siguiente
                </Button>
              </div>
            </form>
          </div>
          }

          { stepPesadoManual === 1 && <div className='container-peso-cabezal container-peso-bruto'>
            <form onSubmit={submitAltaPesado}>
              <Field
                className='peso-cabezal peso-cabezal-bruto'
                name='pesoBruto'
                type='text'
                component={renderTextField}
                autoFocus
                label='Peso bruto'
                maxLength={5}
                placeholder='55000'
              />

              <div style={{ visibility: '1', display: 'none' }}>
                <Button
                  type='submit'
                >
                    Confirmar
                </Button>
              </div>
            </form>
          </div>
          }
        </>
      }
    </div>

  )
}

const selector = formValueSelector(FORM_PESO_BRUTO)

const mapStateToProps = (state) => ({
  cpe: state.pesado.cpePesadoBruto,
  numero: selector(state, 'numero'),
  pesoBruto: selector(state, 'pesoBruto'),
  pesoMinimo: state.pesado.pesoMinimo,
  pesoAdvertencia: state.pesado.pesoMaximoAdvertencia
})

const withRedux = connect(mapStateToProps, null)

const withReduxForm = reduxForm({
  form: FORM_PESO_BRUTO
})

export default withRedux(withReduxForm(PesadoBalanzaModoManual))
